import { ONE_PAGE_STORE_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

export const onTrackCheckoutNameInput = async () => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: ONE_PAGE_STORE_TRACKER_TYPE.CheckoutNameInput,
    data: {
      event_category: 'Checkout',
      scope: 'one_page_store',
    },
  });
};
